import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutEncounterNewLocationInterface {
  objectSlug: string;
  encounterId: number;
  newLocationData: { x_coord: number; y_coord: number; floor_plan: string };
}

export const putEncounterNewLocation = async ({
  objectSlug,
  encounterId,
  newLocationData,
}: PutEncounterNewLocationInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/encounters/${objectSlug}/${encounterId}/change-position/`,
    newLocationData,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
